import { Component, inject, OnInit } from '@angular/core';
import { SepaSafeguardService } from '../../services/sepa-safeguard/sepa-safeguard.service';
import { SafeguardRunHistory } from '../../models/sepa-safeguard';

@Component({
  selector: 'lib-sepa-safeguard-history',
  standalone: false,
  templateUrl: './sepa-safeguard-history.component.html',
  styleUrl: './sepa-safeguard-history.component.scss'
})
export class SepaSafeguardHistoryComponent implements OnInit {
  protected sepaSafeguardService = inject(SepaSafeguardService);

  history: SafeguardRunHistory[] = [];
  expandedRows = new Set<string>();
  loaded = false;

  ngOnInit(): void {
    this.sepaSafeguardService.getRunHistory().subscribe({
      next: history => {
        this.history = history;
        this.loaded = true;
      },
      error: () => {
        this.history = [];
        this.loaded = true;
      }
    });
  }

  toggleExpand(id: string): void {
    if (this.expandedRows.has(id)) {
      this.expandedRows.delete(id);
    } else {
      this.expandedRows.add(id);
    }
  }

  getStatusClass(run: SafeguardRunHistory): string {
    if (run.blocked && !run.overrideUsed) {
      return 'text-danger';
    }
    if (run.overrideUsed) {
      return 'text-warning';
    }
    return 'text-success';
  }

  getStatusLabel(run: SafeguardRunHistory): string {
    if (run.blocked && !run.overrideUsed) {
      return 'BLOCKED';
    }
    if (run.overrideUsed) {
      return 'OVERRIDDEN';
    }
    return 'SENT';
  }
}
